import React from 'react';

import { CssModuleType } from '@utils/cssModules';

import currentCssModule from './Sidebar.module.scss';
import Accordion from '../../components/Accordion';
import Typography from '../../kit/atoms/Typography/Typography';
import AppliedFilters from '../../components/AppliedFilters';
import { Facet, FacetData } from '../../types';

export interface SidebarProps {
    facetsData?: Facet[];
    activeFilters?: FacetData[];
    handleToggleFilter?: (filter: FacetData) => void;
    handleRemoveFilter?: (facetName: string, value: string) => void;
    isItemActive?: (facetName: string, value: string) => boolean;
    clearAllFilters?: () => void;
}

const Sidebar: React.FC<SidebarProps> = ({
    facetsData,
    activeFilters,
    handleToggleFilter,
    handleRemoveFilter,
    isItemActive,
    clearAllFilters
}) => {
    const st: CssModuleType = currentCssModule;

    return (
        <div className={st.sidebar}>
            <Typography variant='p' className={st['sidebar__heading']}>
                Filter by:
            </Typography>
            <AppliedFilters
                filters={activeFilters}
                onRemoveFilter={handleRemoveFilter}
                clearAllFilters={clearAllFilters}
            />
            <Accordion
                data={facetsData}
                activeFilters={activeFilters}
                onToggle={handleToggleFilter}
                isItemActive={isItemActive}
            />
        </div>
    );
};

export default Sidebar;
